import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'

export function useIsBuyingPartyView() {
  const isBuyingPartyView = useAppSelector(
    (state: RootAppState) => state.project?.activeProject?.isBuyingPartyView
  )

  return isBuyingPartyView
}
